import styled from "styled-components";
import { Swiper } from "swiper/react";

export const StyledSuggestedProductSwiper = styled(Swiper)`
    width: 100%;

    & .swiper-slide {
        height: auto;
    }

    & .swiper-button-prev {
        left: 0 !important;
        top: 50% !important;
        border-radius: 0;
        background-color: #F4F4F5;
    }

    & .swiper-button-prev::after {
        font-size: 1.8rem;
        color: #000000;
    }

    & .swiper-button-prev.swiper-button-disabled::after {
        background-color: #F4F4F5;    
        color: #CBCBCB;
    }

    @media (min-width: 277px) {
        & .swiper-button-prev {
            display: flex;
        }
    }

    & .swiper-button-next {
        right: 0 !important;
        top: 50% !important;
        border-radius: 0;
        background-color: #F4F4F5;
    }

    & .swiper-button-next::after {
        font-size: 1.8rem;
        color: #000000;
    }
    
    & .swiper-button-next.swiper-button-disabled::after {
        background-color: #F4F4F5;
        color: #CBCBCB;
    }

    @media (min-width: 277px) {
        & .swiper-button-next {
            display: flex;
        }
    }
`;

export const StyledSuggestedProductSwiperMiniCart = styled(StyledSuggestedProductSwiper)`{
}`;

export const StyledSuggestedProductSwiperCheckout = styled(StyledSuggestedProductSwiper)`{
    padding-top: 3rem;

    & .swiper-button-next,
    & .swiper-button-prev {
        transform: translateY(-50%);
    }
}`;